/* eslint-disable import/prefer-default-export */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import I18n from 'i18n-js';
import {
  SCRIBE_SHOPIFY_STATES,
  SCRIBE_SHOPIFY_EVENTS,
} from 'applications/scribe/instrumentations/track';
import ShopifyTrackEventContext from 'views/v2/shopify-home/track-event';
import { ROUTES_V2_PATHS } from 'constants/route-constants';
import { Button, Modal } from 'grab-ui';
import shopifyGrabExpress from 'public/images/shopify-x-grabexpress.png';
import { SeenShopSetupModalSessionStorage } from '../utils/storage';
import { isShopConfigurationRequired } from '../utils';
import styles from './setup-shop-modal.less';

const localeKeyPrefix = 'shopify.home.setupShopModal';

export const SetupShopModal = ({ shop }) => {
  const { fireShopifyTrackEvent } = React.useContext(ShopifyTrackEventContext);

  const fireWelcomeModalTrackEvent = () => {
    fireShopifyTrackEvent({
      stateName: SCRIBE_SHOPIFY_STATES.EXPRESS_SHOPIFY_WELCOME_GO_SETTINGS_WEB,
      eventName: SCRIBE_SHOPIFY_EVENTS.DEFAULT,
    });
  };

  const fireLaterTrackEvent = () => {
    fireShopifyTrackEvent({
      stateName: SCRIBE_SHOPIFY_STATES.EXPRESS_SHOPIFY_WELCOME_GO_SETTINGS_WEB,
      eventName: SCRIBE_SHOPIFY_EVENTS.LATER,
    });
  };

  const fireGoToSettingsTrackEvent = () => {
    fireShopifyTrackEvent({
      stateName: SCRIBE_SHOPIFY_STATES.EXPRESS_SHOPIFY_WELCOME_GO_SETTINGS_WEB,
      eventName: SCRIBE_SHOPIFY_EVENTS.GO_TO_SETTINGS,
    });
  };

  const [visible, setVisible] = React.useState(false);
  const checkIfShouldShowModal = React.useCallback(
    () => {
      const requiresConfiguration = isShopConfigurationRequired(shop);
      const hasNotSeenModal = !SeenShopSetupModalSessionStorage.hasSeenShopSetupModal(
        shop.shop,
      );
      return requiresConfiguration && hasNotSeenModal;
    },
    [shop],
  );

  const location = {
    pathname: ROUTES_V2_PATHS.shopifySettings,
    state: {
      shopConfiguration: shop,
    },
  };

  const seenShopModal = () => {
    SeenShopSetupModalSessionStorage.setSeenShopSetupModal(shop.shop);
  };

  const cancelHandler = () => {
    seenShopModal();
    setVisible(false);
    fireLaterTrackEvent();
  };

  const goToSettingsHandler = () => {
    seenShopModal();
    fireGoToSettingsTrackEvent();
  };

  React.useEffect(
    () => {
      if (checkIfShouldShowModal()) {
        setVisible(true);
        fireWelcomeModalTrackEvent();
      }
    },
    [checkIfShouldShowModal],
  );

  return (
    <Modal
      centered
      closable={false}
      maskClosable={false}
      visible={visible}
      className={styles.SetupShopModal}
      footer={null}
    >
      <div className={styles.Content}>
        <div className={styles.ImageContainer}>
          <img src={shopifyGrabExpress} alt={'logo'} />
        </div>
        <p className={styles.title}>{I18n.t(`${localeKeyPrefix}.heading`)}</p>
        <p className={styles.message}>{I18n.t(`${localeKeyPrefix}.message`)}</p>
        <div className={styles.ActionButtonsContainer}>
          <Button
            className={styles.ActionButton}
            size={'large'}
            onClick={cancelHandler}
          >
            {I18n.t(`${localeKeyPrefix}.buttonLabels.later`)}
          </Button>
          <Link to={location}>
            <Button
              className={styles.ActionButton}
              size={'large'}
              type="primary"
              onClick={goToSettingsHandler}
            >
              {I18n.t(`${localeKeyPrefix}.buttonLabels.goToSettings`)}
            </Button>
          </Link>
        </div>
      </div>
    </Modal>
  );
};

SetupShopModal.propTypes = {
  shop: PropTypes.shape({}).isRequired,
};
